import type { NotificationItemSourceSourceUser } from './notificationItemSourceSourceUser';

export type NotificationItemSource = {
  sourceUser?: NotificationItemSourceSourceUser;
  /** @nullable */
  sourceUserId?: number | null;
};
